'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconAt, iconAtTag } from '@ni/nimble-components/dist/esm/icons/at';
import { wrap } from '../../utilities/react-wrapper';

export type { IconAt };
export { iconAtTag };
export const NimbleIconAt = wrap(IconAt);